export default __webpack_public_path__ + "static/157-min-min-3951dc2d69e4c40631e53ef4fdaee8d9.jpg";